module.exports = __webpack_public_path__ + "3eccff266309e8e28fcd1415f37edfad.MP3";